module.exports = __webpack_public_path__ + "media/left.e5b69423.svg";